import DosenDiProdi from "../DosenDiProdi";
import MasaStudi from "../MasaStudi";
import MinimalIpk from "../MinimalIpk";
import React, { Component } from "react";
import AppConfig from "../../../../../config/AppConfig";
import axios from "axios";
import { LinearProgress } from "@material-ui/core";
class TargetPerguruanTinggi extends Component {
  state = {
    ref_data: [],
    ref_dosen_tetap: [],
    ref_ipk: [],
    ref_masa_studi: [],
    display: false,
  };
  componentDidMount() {
    this.setState({ display: false });
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let data_PT = AppConfig.urlGetTarget;
    let rq_data = axios.get(data_PT + id_sp);
    axios
      .all([rq_data])
      .then(
        axios.spread((...responses) => {
          let resp = responses[0];

          let ref = {
            refrensi: resp.data.result.target_penetapan,
          };
          this.setState(
            {
              ref_data: ref,
              ref_dosen_tetap: ref.refrensi["DOSEN TETAP"],
              ref_ipk: ref.refrensi["IPK MINIMAL PADA JENJANG PENDIDIKAN"],
              ref_masa_studi:
                ref.refrensi["MASA STUDI MAKSIMAL PADA JENJANG PENDIDIKAN"],
              display: true,
            },
            () => {
              console.log(resp);
            }
          );
        })
      )
      .catch((errors) => {
        console.log(errors);
      });
  }
  render() {
    let { ref_dosen_tetap, ref_ipk, ref_masa_studi, display } = this.state;
    let view = [];
    if (display === true) {
      view = (
        <>
          <div className={`card card-custom `} style={{ boxShadow: "none" }}>
            <div className="text-center">
              <strong style={{ fontSize: "20px" }}>MAHASISWA</strong>
              <p>
                Tetapkan Masa Studi Maksimal Dan IPK Minimal Di Perguruan Tinggi
              </p>
              <br />
            </div>
            <MasaStudi ref_data={ref_masa_studi} />
            <hr style={{ borderTop: "1px dashed" }} />
            <MinimalIpk ref_data={ref_ipk} />
            <hr style={{ borderTop: "1px dashed" }} />
            <DosenDiProdi ref_data={ref_dosen_tetap} />
            {/* end::Body */}
          </div>
        </>
      );
    } else {
      view = (
        <>
          <div
            className={`card card-custom `}
            style={{ boxShadow: "none", padding: "1%" }}
          >
            <LinearProgress color="secondary" variant="query" />
          </div>
        </>
      );
    }
    // console.log("Data refrensi ref_masa_studi = ", this.state.ref_masa_studi);
    return <>{view}</>;
  }
}
export default TargetPerguruanTinggi;
